// extracted by mini-css-extract-plugin
module.exports = {"faqPage":"FaqPage_faqPage__3bBGl","faqList":"FaqPage_faqList__Qu_Ms","faqListContainer":"FaqPage_faqListContainer__3NTnC","faqLink":"FaqPage_faqLink__2nBBu"};